import { Actions } from './administrationActions';

/**
 * Etat initial groupes
 */
const initialState = {
    groupes: {
        items: [],
        isLoading: false,
        isPatching: false
    },
    actionsNonGeneriques:
    {
        items: [],
        isLoading: false
    },
    groupesSecurite: {
        items: [],
        isLoading: false
    },
    transporteurs: {
        items: [],
        isLoading: false,
        isPatching: false
    },
    motifsResolution: {
        items: [],
        avecNbActions: false,
        isLoading: false,
        isPatching: false
    },
    causesPrincipales: {
        items: [],
        avecNbActions: false,
        isLoading: false,
        isPatching: false
    },
    clients: {
        prioritaires: {
            items: [],
            isLoading: false,
            isPatching: false
        },
        isPatching: false
    },
    fournisseurs: {
        isPatching: false
    },
    fraisRetourExclus: {
        items: [],
        niveaux: [],
        isLoading: false,
        isPatching: false
    },
    decoteRetourExclus: {
        items: [],
        niveaux: [],
        isLoading: false,
        isPatching: false
    },
    montantMiniRetourExclus: {
        items: [],
        niveaux: [],
        isLoading: false,
        isPatching: false
    },
    retourExclus: {
        items: [],
        niveaux: [],
        isLoading: false,
        isPatching: false
    },
    interlocuteursSAV: {
        //items: [],
        //types: [],
        //isLoading: false,
        isPatching: false
    },
    representants: {
        isPatching: false
    }
};

/**
 * Reducer pour les groupes
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {
        case Actions.FETCH_ADMINISTRATION_GROUPES_REQUEST:
            return {
                ...state,
                groupes: { ...state.groupes, isLoading: true }
            };
        case Actions.FETCH_ADMINISTRATION_GROUPES_SUCCESS:
            return {
                ...state,
                groupes: { ...state.groupes, items: [...action.items], isLoading: false }
            };
        case Actions.FETCH_ADMINISTRATION_GROUPES_FAILURE:
            return {
                ...state,
                groupes: { ...state.groupes, isLoading: false, error: action.error }
            };

        case Actions.FETCH_ADMINISTRATION_GROUPE_REQUEST:
            return {
                ...state,
                groupes: { ...state.groupes, isLoading: true }
            };
        case Actions.FETCH_ADMINISTRATION_GROUPE_SUCCESS:
            {
                let items = [...state.groupes.items];

                let insertIndex = items.findIndex(x => x.id === action.item.id);

                if (insertIndex === -1) {
                    items.push({ ...action.item });
                }
                else {
                    items.splice(insertIndex, 1, { ...action.item });
                }

                return {
                    ...state,
                    groupes: {
                        ...state.groupes,
                        isLoading: false,
                        items: items
                    }
                };
            }
        case Actions.FETCH_ADMINISTRATION_GROUPE_FAILURE:
            return {
                ...state,
                groupes: { ...state.groupes, isLoading: false, error: action.error }
            };

        case Actions.PATCH_GROUPE_REQUEST:
            return {
                ...state,
                groupes: { ...state.groupes, isPatching: true }
            };
        case Actions.PATCH_GROUPE_SUCCESS:
            {
                return {
                    ...state,
                    groupes: {
                        ...state.groupes,
                        isPatching: false,
                        items: state.groupes.items.map(x => x.id === action.groupe.id ? {
                            ...x,
                            ...action.groupe,
                            //initiales: action.groupe.initiales,
                            //libelle: action.groupe.libelle,
                            //actif: action.groupe.actif,
                            //visible: action.groupe.visible,
                            //autoriseCreationReclamationLiee: action.groupe.autoriseCreationReclamationLiee,
                            //autoriseSAV: action.groupe.autoriseCreationReclamationLiee,
                            //notifierPilote: action.groupe.notifierPilote,
                            //notifierEmetteurReclamation: action.groupe.notifierEmetteurReclamation,
                            //pilotes: action.groupe.pilotes,
                            //actions: action.groupe.actions,
                            //groupesSecurite: action.groupe.groupesSecurite,
                            //motifsResolution: action.groupe.motifsResolution,
                            //causesPrincipales: action.groupe.causesPrincipales
                        } : x)
                    }
                };

            }
        case Actions.PATCH_GROUPE_FAILURE:
            return {
                ...state,
                groupes: { ...state.groupes, isPatching: false, error: action.error }
            };
        case Actions.FETCH_ADMINISTRATION_ACTIONS_NON_GENERIQUES_REQUEST:
            return {
                ...state,
                actionsNonGeneriques: { ...state.actionsNonGeneriques, isLoading: true }
            };
        case Actions.FETCH_ADMINISTRATION_ACTIONS_NON_GENERIQUES_SUCCESS:
            return {
                ...state,
                actionsNonGeneriques: { ...state.actionsNonGeneriques, items: [...action.items], isLoading: false }
            };
        case Actions.FETCH_ADMINISTRATION_ACTIONS_NON_GENERIQUES_FAILURE:
            return {
                ...state,
                actionsNonGeneriques: { ...state.actionsNonGeneriques, isLoading: false, error: action.error }
            };
        case Actions.FETCH_ADMINISTRATION_GROUPES_SECURITE_REQUEST:
            return {
                ...state,
                groupesSecurite: { ...state.groupesSecurite, isLoading: true }
            };
        case Actions.FETCH_ADMINISTRATION_GROUPES_SECURITE_SUCCESS:
            return {
                ...state,
                groupesSecurite: { ...state.groupesSecurite, items: [...action.items], isLoading: false }
            };
        case Actions.FETCH_ADMINISTRATION_GROUPES_SECURITE_FAILURE:
            return {
                ...state,
                groupesSecurite: { ...state.groupesSecurite, isLoading: false, error: action.error }
            };
        case Actions.FETCH_ADMINISTRATION_TRANSPORTEURS_REQUEST:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isLoading: true }
            };
        case Actions.FETCH_ADMINISTRATION_TRANSPORTEURS_SUCCESS:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, items: [...action.items], isLoading: false }
            };
        case Actions.FETCH_ADMINISTRATION_TRANSPORTEURS_FAILURE:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isLoading: false, error: action.error }
            };
        case Actions.PATCH_TRANSPORTEUR_REQUEST:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isPatching: true }
            };
        case Actions.PATCH_TRANSPORTEUR_SUCCESS:
            {
                return {
                    ...state,
                    transporteurs: {
                        ...state.transporteurs,
                        isPatching: false,
                        items: state.transporteurs.items.map(x => x.id === action.transporteur.id ? {
                            ...x,
                            nom: action.transporteur.nom,
                            type: action.transporteur.type,
                            transporteursLogistique: action.transporteur.transporteursLogistique
                        } : x)
                    }
                };

            }
        case Actions.PATCH_TRANSPORTEUR_FAILURE:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isPatching: false, error: action.error }
            };
        case Actions.POST_TRANSPORTEUR_REQUEST:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isPatching: true }
            };
        case Actions.POST_TRANSPORTEUR_SUCCESS:
            {
                return {
                    ...state,
                    transporteurs: {
                        ...state.transporteurs,
                        isPatching: false,
                        items: [...state.transporteurs.items, action.transporteur]
                    }
                };
            }
        case Actions.POST_TRANSPORTEUR_FAILURE:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isPatching: false, error: action.error }
            };
        case Actions.DELETE_TRANSPORTEUR_REQUEST:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isPatching: true }
            };
        case Actions.DELETE_TRANSPORTEUR_SUCCESS:
            {
                return {
                    ...state,
                    transporteurs: {
                        ...state.transporteurs,
                        isPatching: false,
                        items: state.transporteurs.items.filter(transporteur => transporteur.id !== action.transporteurId)
                    }
                };
            }
        case Actions.DELETE_TRANSPORTEUR_FAILURE:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isPatching: false, error: action.error }
            };
        case Actions.POST_TRANSPORTEUR_COMPTE_REQUEST:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isPatching: true }
            };
        case Actions.POST_TRANSPORTEUR_COMPTE_SUCCESS:
            {
                return {
                    ...state,
                    transporteurs: {
                        ...state.transporteurs,
                        isPatching: false,
                        items: state.transporteurs.items.map(x => x.id !== action.transporteurCompte.transporteurId ? { ...x } : { ...x, comptes: [...x.comptes, action.transporteurCompte] })
                    }
                };
            }
        case Actions.POST_TRANSPORTEUR_COMPTE_FAILURE:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isPatching: false, error: action.error }
            };
        case Actions.DELETE_TRANSPORTEUR_COMPTE_REQUEST:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isPatching: true }
            };
        case Actions.DELETE_TRANSPORTEUR_COMPTE_SUCCESS:
            {
                return {
                    ...state,
                    transporteurs: {
                        ...state.transporteurs,
                        isPatching: false,
                        items: state.transporteurs.items.map(x => x.id !== action.transporteurId ? { ...x } : { ...x, comptes: x.comptes.filter(y => y.id !== action.transporteurCompteId) })

                    }
                };
            }
        case Actions.DELETE_TRANSPORTEUR_COMPTE_FAILURE:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isPatching: false, error: action.error }
            };
        case Actions.PATCH_TRANSPORTEUR_COMPTE_REQUEST:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isPatching: true }
            };
        case Actions.PATCH_TRANSPORTEUR_COMPTE_SUCCESS:
            {
                let transporteurId = action.payload.transporteurId;
                let transporteurCompte = action.payload.transporteurCompte;
                
                return {
                    ...state,
                    transporteurs: {
                        ...state.transporteurs,
                        isPatching: false,
                        items: state.transporteurs.items.map(x => x.id !== transporteurId
                            ? { ...x }
                            : { ...x, comptes: x.comptes.map(c => c.id !== transporteurCompte.id ? { ...c } : transporteurCompte) })
                    }
                };
            }
        case Actions.PATCH_TRANSPORTEUR_COMPTE_FAILURE:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isPatching: false, error: action.error }
            };
        case Actions.SET_DEFAUT_TRANSPORTEUR_COMPTE_REQUEST:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isPatching: true }
            };
        case Actions.SET_DEFAUT_TRANSPORTEUR_COMPTE_SUCCESS:
            {
                let transporteurId = action.payload.transporteurId;
                let transporteurCompteId = action.payload.transporteurCompteId;

                return {
                    ...state,
                    transporteurs: {
                        ...state.transporteurs,
                        isPatching: false,
                        items: state.transporteurs.items.map(x => x.id !== transporteurId
                            ? { ...x }
                            : { ...x, comptes: x.comptes.map(c => c.id === transporteurCompteId ? { ...c, defaut: true } : { ...c, defaut: false }) })
                    }
                };
            }
        case Actions.SET_DEFAUT_TRANSPORTEUR_COMPTE_FAILURE:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isPatching: false, error: action.error }
            };
        case Actions.FETCH_ADMINISTRATION_MOTIFS_RESOLUTION_REQUEST:
            return {
                ...state,
                motifsResolution: { ...state.motifsResolution, isLoading: true, avecNbActions: state.motifsResolution.avecNbActions || action.param.avecNbActions }
            };
        case Actions.FETCH_ADMINISTRATION_MOTIFS_RESOLUTION_SUCCESS:
            return {
                ...state,
                motifsResolution: { ...state.motifsResolution, items: [...action.items], isLoading: false }
            };
        case Actions.FETCH_ADMINISTRATION_MOTIFS_RESOLUTION_FAILURE:
            return {
                ...state,
                motifsResolution: { ...state.motifsResolution, isLoading: false, error: action.error, avecNbActions: false }
            };
        case Actions.PATCH_MOTIF_RESOLUTION_REQUEST:
            return {
                ...state,
                motifsResolution: { ...state.motifsResolution, isPatching: true }
            };
        case Actions.PATCH_MOTIF_RESOLUTION_SUCCESS:
            {
                return {
                    ...state,
                    motifsResolution: {
                        ...state.motifsResolution,
                        isPatching: false,
                        items: state.motifsResolution.items.map(x => x.id === action.motifResolution.id ? {
                            ...x,
                            libelle: action.motifResolution.libelle,
                            nbActions: action.motifResolution.nbActions,
                            groupesTraitement: action.motifResolution.GroupesTraitement
                        } : x)
                    }
                };

            }
        case Actions.PATCH_MOTIF_RESOLUTION_FAILURE:
            return {
                ...state,
                motifsResolution: { ...state.motifsResolution, isPatching: false, error: action.error }
            };
        case Actions.POST_MOTIF_RESOLUTION_REQUEST:
            return {
                ...state,
                motifsResolution: { ...state.motifsResolution, isPatching: true }
            };
        case Actions.POST_MOTIF_RESOLUTION_SUCCESS:
            {
                return {
                    ...state,
                    motifsResolution: {
                        ...state.motifsResolution,
                        isPatching: false,
                        items: [...state.motifsResolution.items, action.motifResolution]
                    }
                };
            }
        case Actions.POST_MOTIF_RESOLUTION_FAILURE:
            return {
                ...state,
                motifsResolution: { ...state.motifsResolution, isPatching: false, error: action.error }
            };
        case Actions.DELETE_MOTIF_RESOLUTION_REQUEST:
            return {
                ...state,
                motifsResolution: { ...state.motifsResolution, isPatching: true }
            };
        case Actions.DELETE_MOTIF_RESOLUTION_SUCCESS:
            {
                return {
                    ...state,
                    motifsResolution: {
                        ...state.motifsResolution,
                        isPatching: false,
                        items: state.motifsResolution.items.filter(motifResolution => motifResolution.id !== action.motifResolutionId)
                    }
                };
            }
        case Actions.DELETE_MOTIF_RESOLUTION_FAILURE:
            return {
                ...state,
                motifsResolution: { ...state.motifsResolution, isPatching: false, error: action.error }
            };
        case Actions.FETCH_ADMINISTRATION_CAUSES_PRINCIPALES_REQUEST:
            return {
                ...state,
                causesPrincipales: { ...state.causesPrincipales, isLoading: true, avecNbActions: state.causesPrincipales.avecNbActions || action.param.avecNbActions }
            };
        case Actions.FETCH_ADMINISTRATION_CAUSES_PRINCIPALES_SUCCESS:
            return {
                ...state,
                causesPrincipales: { ...state.causesPrincipales, items: [...action.items], isLoading: false }
            };
        case Actions.FETCH_ADMINISTRATION_CAUSES_PRINCIPALES_FAILURE:
            return {
                ...state,
                causesPrincipales: { ...state.causesPrincipales, isLoading: false, error: action.error, avecNbActions: false }
            };
        case Actions.PATCH_CAUSE_PRINCIPALE_REQUEST:
            return {
                ...state,
                causesPrincipales: { ...state.causesPrincipales, isPatching: true }
            };
        case Actions.PATCH_CAUSE_PRINCIPALE_SUCCESS:
            {
                return {
                    ...state,
                    causesPrincipales: {
                        ...state.causesPrincipales,
                        isPatching: false,
                        items: state.causesPrincipales.items.map(x => x.id === action.causePrincipale.id ? {
                            ...x,
                            libelle: action.causePrincipale.libelle,
                            nbActions: action.causePrincipale.nbActions,
                            //groupesTraitement: action.causePrincipale.groupesTraitement,
                            details: action.causePrincipale.details
                        } : x)
                    }
                };

            }
        case Actions.PATCH_CAUSE_PRINCIPALE_FAILURE:
            return {
                ...state,
                causesPrincipales: { ...state.causesPrincipales, isPatching: false, error: action.error }
            };
        case Actions.POST_CAUSE_PRINCIPALE_REQUEST:
            return {
                ...state,
                causesPrincipales: { ...state.causesPrincipales, isPatching: true }
            };
        case Actions.POST_CAUSE_PRINCIPALE_SUCCESS:
            {
                return {
                    ...state,
                    causesPrincipales: {
                        ...state.causesPrincipales,
                        isPatching: false,
                        items: [...state.causesPrincipales.items, action.causePrincipale]
                    }
                };
            }
        case Actions.POST_CAUSE_PRINCIPALE_FAILURE:
            return {
                ...state,
                causesPrincipales: { ...state.causesPrincipales, isPatching: false, error: action.error }
            };
        case Actions.DELETE_CAUSE_PRINCIPALE_REQUEST:
            return {
                ...state,
                causesPrincipales: { ...state.causesPrincipales, isPatching: true }
            };
        case Actions.DELETE_CAUSE_PRINCIPALE_SUCCESS:
            {
                return {
                    ...state,
                    causesPrincipales: {
                        ...state.causesPrincipales,
                        isPatching: false,
                        items: state.causesPrincipales.items.filter(causePrincipale => causePrincipale.id !== action.causePrincipaleId)
                    }
                };
            }
        case Actions.DELETE_CAUSE_PRINCIPALE_FAILURE:
            return {
                ...state,
                causesPrincipales: { ...state.causesPrincipales, isPatching: false, error: action.error }
            };
        case Actions.FETCH_CLIENTS_PRIORITAIRES_REQUEST:
            return {
                ...state,
                clients: {
                    ...state.clients,
                    prioritaires: {
                        items: [],
                        isLoading: true,
                        isPatching: false
                    }
                }
            };
        case Actions.FETCH_CLIENTS_PRIORITAIRES_SUCCESS:
            return {
                ...state,
                clients: {
                    ...state.clients,
                    prioritaires: {
                        items: [...action.items],
                        isLoading: false,
                        isPatching: false
                    }
                }
            };
        case Actions.FETCH_CLIENTS_PRIORITAIRES_FAILURE:
            return {
                ...state,
                clients: {
                    ...state.clients,
                    prioritaires: {
                        items: [],
                        isLoading: false,
                        isPatching: false,
                        error: action
                    }
                }
            };
        case Actions.CLEAR_CLIENTS_PRIORITAIRES:
            return {
                ...state,
                clients: {
                    ...state.clients,
                    prioritaires: {
                        items: [],
                        isLoading: true,
                        isPatching: false
                    }
                }
            };
        case Actions.IMPORT_CLIENTS_PRIORITAIRES_REQUEST:
            return {
                ...state,
                clients: {
                    ...state.clients,
                    prioritaires: {
                        items: [],
                        isLoading: false,
                        isPatching: true,
                        importResult: null,
                        error: ''
                    }
                }
            };
        case Actions.IMPORT_CLIENTS_PRIORITAIRES_SUCCESS:
            return {
                ...state,
                clients: {
                    ...state.clients,
                    prioritaires: {
                        items: [],
                        isLoading: false,
                        isPatching: false,
                        importResult: action.importResult,
                        error: ''
                    }
                }
            };
        case Actions.IMPORT_CLIENTS_PRIORITAIRES_FAILURE:
            return {
                ...state,
                clients: {
                    ...state.clients,
                    prioritaires: {
                        items: [],
                        isLoading: false,
                        isPatching: false,
                        message: action.message,
                        error: action
                    }
                }
            };
        case Actions.PATCH_CLIENT_REQUEST:
            return {
                ...state,
                clients: { ...state.clients, isPatching: true }
            };
        case Actions.PATCH_CLIENT_SUCCESS:
            return {
                ...state,
                clients: { ...state.clients, isPatching: false }
            };
        case Actions.PATCH_CLIENT_FAILURE:
            return {
                ...state,
                clients: { ...state.clients, isPatching: false, error: action.error }
            };
        case Actions.PATCH_FOURNISSEUR_REQUEST:
            return {
                ...state,
                fournisseurs: { ...state.fournisseurs, isPatching: true }
            };
        case Actions.PATCH_FOURNISSEUR_SUCCESS:
            return {
                ...state,
                fournisseurs: { ...state.fournisseurs, isPatching: false }
            };
        case Actions.PATCH_FOURNISSEUR_FAILURE:
            return {
                ...state,
                fournisseurs: { ...state.fournisseurs, isPatching: false, error: action.error }
            };
        case Actions.FETCH_ADMINISTRATION_FRAIS_RETOUR_EXCLUS_REQUEST:
            return {
                ...state,
                fraisRetourExclus: { ...state.fraisRetourExclus, isLoading: true }
            };
        case Actions.FETCH_ADMINISTRATION_FRAIS_RETOUR_EXCLUS_SUCCESS:
            return {
                ...state,
                fraisRetourExclus: { ...state.fraisRetourExclus, items: [...action.items.items], niveaux: [...action.items.niveaux], isLoading: false }
            };
        case Actions.FETCH_ADMINISTRATION_FRAIS_RETOUR_EXCLUS_FAILURE:
            return {
                ...state,
                fraisRetourExclus: { ...state.fraisRetourExclus, isLoading: false, error: action.error }
            };
        case Actions.POST_FRAIS_RETOUR_EXCLU_REQUEST:
            return {
                ...state,
                fraisRetourExclus: { ...state.fraisRetourExclus, isPatching: true }
            };
        case Actions.POST_FRAIS_RETOUR_EXCLU_SUCCESS:
            {
                return {
                    ...state,
                    fraisRetourExclus: {
                        ...state.fraisRetourExclus,
                        isPatching: false,
                        items: [...state.fraisRetourExclus.items, action.fraisRetourExclu]
                    }
                };
            }
        case Actions.POST_FRAIS_RETOUR_EXCLU_FAILURE:
            return {
                ...state,
                fraisRetourExclus: { ...state.fraisRetourExclus, isPatching: false, error: action.error }
            };
        case Actions.DELETE_FRAIS_RETOUR_EXCLU_REQUEST:
            return {
                ...state,
                fraisRetourExclus: { ...state.fraisRetourExclus, isPatching: true }
            };
        case Actions.DELETE_FRAIS_RETOUR_EXCLU_SUCCESS:
            {
                return {
                    ...state,
                    fraisRetourExclus: {
                        ...state.fraisRetourExclus,
                        isPatching: false,
                        items: state.fraisRetourExclus.items.filter(fraisRetourExclu => fraisRetourExclu.id !== action.fraisRetourExcluId)
                    }
                };
            }
        case Actions.DELETE_FRAIS_RETOUR_EXCLU_FAILURE:
            return {
                ...state,
                fraisRetourExclus: { ...state.fraisRetourExclus, isPatching: false, error: action.error }
            };




        case Actions.FETCH_ADMINISTRATION_DECOTE_RETOUR_EXCLUS_REQUEST:
            return {
                ...state,
                decoteRetourExclus: { ...state.decoteRetourExclus, isLoading: true }
            };
        case Actions.FETCH_ADMINISTRATION_DECOTE_RETOUR_EXCLUS_SUCCESS:
            return {
                ...state,
                decoteRetourExclus: { ...state.decoteRetourExclus, items: [...action.items.items], niveaux: [...action.items.niveaux], isLoading: false }
            };
        case Actions.FETCH_ADMINISTRATION_DECOTE_RETOUR_EXCLUS_FAILURE:
            return {
                ...state,
                decoteRetourExclus: { ...state.decoteRetourExclus, isLoading: false, error: action.error }
            };
        case Actions.POST_DECOTE_RETOUR_EXCLU_REQUEST:
            return {
                ...state,
                decoteRetourExclus: { ...state.decoteRetourExclus, isPatching: true }
            };
        case Actions.POST_DECOTE_RETOUR_EXCLU_SUCCESS:
            {
                return {
                    ...state,
                    decoteRetourExclus: {
                        ...state.decoteRetourExclus,
                        isPatching: false,
                        items: [...state.decoteRetourExclus.items, action.decoteRetourExclu]
                    }
                };
            }
        case Actions.POST_DECOTE_RETOUR_EXCLU_FAILURE:
            return {
                ...state,
                decoteRetourExclus: { ...state.decoteRetourExclus, isPatching: false, error: action.error }
            };
        case Actions.DELETE_DECOTE_RETOUR_EXCLU_REQUEST:
            return {
                ...state,
                decoteRetourExclus: { ...state.decoteRetourExclus, isPatching: true }
            };
        case Actions.DELETE_DECOTE_RETOUR_EXCLU_SUCCESS:
            {
                return {
                    ...state,
                    decoteRetourExclus: {
                        ...state.decoteRetourExclus,
                        isPatching: false,
                        items: state.decoteRetourExclus.items.filter(decoteRetourExclu => decoteRetourExclu.id !== action.decoteRetourExcluId)
                    }
                };
            }
        case Actions.DELETE_DECOTE_RETOUR_EXCLU_FAILURE:
            return {
                ...state,
                decoteRetourExclus: { ...state.decoteRetourExclus, isPatching: false, error: action.error }
            };



        case Actions.FETCH_ADMINISTRATION_RETOUR_EXCLUS_REQUEST:
            return {
                ...state,
                retourExclus: { ...state.retourExclus, isLoading: true }
            };
        case Actions.FETCH_ADMINISTRATION_RETOUR_EXCLUS_SUCCESS:
            return {
                ...state,
                retourExclus: { ...state.retourExclus, items: [...action.items.items], niveaux: [...action.items.niveaux], isLoading: false }
            };
        case Actions.FETCH_ADMINISTRATION_RETOUR_EXCLUS_FAILURE:
            return {
                ...state,
                retourExclus: { ...state.retourExclus, isLoading: false, error: action.error }
            };
        case Actions.POST_RETOUR_EXCLU_REQUEST:
            return {
                ...state,
                retourExclus: { ...state.retourExclus, isPatching: true }
            };
        case Actions.POST_RETOUR_EXCLU_SUCCESS:
            {
                return {
                    ...state,
                    retourExclus: {
                        ...state.retourExclus,
                        isPatching: false,
                        items: [...state.retourExclus.items, action.retourExclu]
                    }
                };
            }
        case Actions.POST_RETOUR_EXCLU_FAILURE:
            return {
                ...state,
                retourExclus: { ...state.retourExclus, isPatching: false, error: action.error }
            };
        case Actions.DELETE_RETOUR_EXCLU_REQUEST:
            return {
                ...state,
                retourExclus: { ...state.retourExclus, isPatching: true }
            };
        case Actions.DELETE_RETOUR_EXCLU_SUCCESS:
            {
                return {
                    ...state,
                    retourExclus: {
                        ...state.retourExclus,
                        isPatching: false,
                        items: state.retourExclus.items.filter(retourExclu => retourExclu.id !== action.retourExcluId)
                    }
                };
            }
        case Actions.DELETE_RETOUR_EXCLU_FAILURE:
            return {
                ...state,
                retourExclus: { ...state.retourExclus, isPatching: false, error: action.error }
            };
        case Actions.PATCH_REPRESENTANT_REQUEST:
            return {
                ...state,
                representants: { ...state.representants, isPatching: true }
            };
        case Actions.PATCH_REPRESENTANT_SUCCESS:
            return {
                ...state,
                representants: { ...state.representants, isPatching: false }
            };
        case Actions.PATCH_REPRESENTANT_FAILURE:
            return {
                ...state,
                representants: { ...state.representants, isPatching: false, error: action.error }
            };
        default:
            return state;
    }
};

export default reducer;